import { Component, Prop, h } from '@stencil/core';

/**
 * Badges help draw attention to important content and can provide additional context to UI elements.
 */
@Component({
  tag: 'som-list-item',
  styleUrl: 'som-list-item.scss',
  scoped: true,
})
export class SomListItem {
  /**
   * This property determines what style the list will use.
   */
  @Prop({reflect:true}) type: 'header' | 'panel' | 'dropdown' | 'sidebar' = 'panel';

 /**
   * This boolean is used to set the active list item. 
   */
  @Prop() active: boolean = false;

  /**
   * This boolean is used to set the divider. 
   */
  @Prop() showDivider: boolean = false;

  render() {
    return (
      <div class={`list-item ${this.showDivider && 'border-left'} ${this.type} ${this.active ? 'active' : ''}`}>
        <slot></slot>
      </div>
    );
  }
}
